export default "__VITE_ASSET__2ONiByzV__"